<template>
	<div class="inline">
    <el-button size="medium" :disabled="item.disabled ? item.disabled : false"
     v-for="(item, index) in btnList" :key="index" @click="clkBtn(item.id, item.url)"
    >
    {{item.name}}
    </el-button>
	</div>
</template>
<script>

export default {
	name: 'inputCom',
	props: {
    btnList: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
	methods: {
    clkBtn(methodName, url) {
      this.$emit('clickOpBtn', {name: methodName, url: url})
    }
	},
	created () {
	}
}
</script>



// WEBPACK FOOTER //
// src/components/reports/codeCom/operationBox.vue?44a78222